import React, { useEffect } from 'react';
import Lottie from 'lottie-react';
import { isNil } from 'lodash-es';
import { toast } from 'react-toastify';
import { FormikProvider, useFormik } from 'formik';
import * as yup from 'yup';
import loader from '../../assets/lotties/loader.json';
import './UpdateMenu.scss';
import { useGetMenuByIdQuery, useUpdateMenuMutation } from '../../store/menu/menuApi';
import { ICreateMenuRequest } from '../../proto/menu/menu';

export const schema = yup.object({
	title: yup.string().required('שדה חובה'),
});

interface IUpdateMenuProps {
	menuId: string;
	onSubmit: (data: ICreateMenuRequest) => void;
	onCancel: () => void;
}

export const UpdateMenu = ({ menuId, onSubmit, onCancel }: IUpdateMenuProps): JSX.Element => {
	const { data: menu, isLoading: isLoadingMenu } = useGetMenuByIdQuery(menuId, { skip: isNil(menuId) });

	const [updateMenu] = useUpdateMenuMutation();

	const onFormSubmit = (data: ICreateMenuRequest): void => {
		updateMenu({ ...data, id: menuId })
			.then(() => {
				toast.success(`תפריט עודכן בהצלחה`);

				onSubmit(data);
			})
			.catch((err) => {
				console.error('Failed to upsert menu:', err);
				toast.error('שגיאת עדכון');
			});
	};

	const formik = useFormik<ICreateMenuRequest>({
		initialValues: {
			title: menu?.title || '',
		},
		onSubmit: onFormSubmit,
		enableReinitialize: true,
		validationSchema: schema,
	});

	const { resetForm, handleSubmit, getFieldProps, touched, errors } = formik;

	// reflect fetched menu item into the form
	useEffect(() => {
		if (!isNil(menu)) {
			resetForm({
				values: {
					title: menu?.title || '',
				},
			});
		}
	}, [resetForm, menu]);

	return (
		<div className="updateMenuContainer">
			{isLoadingMenu ? (
				<Lottie animationData={loader} loop style={{ width: '10rem' }} />
			) : (
				<FormikProvider value={formik}>
					<form onSubmit={handleSubmit}>
						{/* Title */}
						<div className="formGroup">
							<label>שם התפריט</label>
							<input {...getFieldProps('title')} />
							{touched.title && errors.title && <p>{errors.title}</p>}
						</div>

						<button type="submit" className="formHandlerButton saveForm">
							שמור
						</button>
						<button type="button" className="formHandlerButton cancelForm" onClick={onCancel}>
							בטל
						</button>
					</form>
				</FormikProvider>
			)}
		</div>
	);
};
